import { memo } from 'react';
import styled, { css } from 'styled-components';

const BaseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  background: ${(props) => props.background || props.theme.colors.yellow};
  width: ${(props) => props.width};
  cursor: pointer;
  position: relative;
  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
  color: rgb(50, 39, 1);
  border-radius: 4px;

  ${(props) => {
    switch (props.type) {
      case 'start':
        return css`
          padding: 8px 18px;
        `;
      default:
        return css`
          padding: 6px 14px;
        `;
    }
  }};
`;

export default memo(BaseButton);
